import { intersect, literal, nullable, partial, string, struct, union } from 'io-ts/Decoder';

import { Id as CustomerId } from '../../../customer/Id';
import { Id as OrganizationId } from '../../../organization/Id';
import { Request as PaginationRequest } from '../../generic/pagination/Request';

export const Request = intersect(
	struct({
		filter: struct({
			organizationId: OrganizationId,
			customerId: nullable(CustomerId),
			//
			field: union(
				literal('jobName'),
				literal('jobRef')
				// literal('customFormData.territorialAuthority')
			),
			searchTerm: string,
		}),
	})
)(
	partial({
		pagination: PaginationRequest,
	})
);
